<!--
배송등록(수동) 에서 사용되는 상품(1개) 컴포넌트

-->
<template>
    <div class="container">
        <div class="uk-flex uk-flex-between uk-flex-bottom">
            <div class="title">상품 ({{ items.length }})</div>


            <div class="add-desc">
                <i class="material-icons">star</i>
                합배송 상품이 있는경우, [상품추가] 클릭하시고 상품내역 입력 바랍니다.
            </div>
        </div>


        <!-- 상품 -->
        <ul class="uk-list prod-list">
            <app-shipping-reg-prod
                :csrf-token="csrfToken"

                ref="prods"
                v-for="(prod, index) in items"
                :key="index"
                :index="index"
                :columns="prod"

                :removeButtonDisable="items.length < 2"
                :removeButtonText="removeButtonText"
                :duplicateButtonText="duplicateButtonText"

                v-on:duplicate="duplicate"
                v-on:remove="remove"

                :hscode-options="hscodeOptions"
                :hscodefull-options="hscodefullOptions"
                :shipping-center-options="shippingCenterOptions"
                :region-currency="regionCurrency"

                @update:totalBuyPrice="calcTotalBuyPrice"
                @add-prod="add"
            ></app-shipping-reg-prod>
        </ul>



        <!-- 총 구매비용 -->
        <div class="total-buy-price uk-flex uk-flex-middle uk-flex-center mt-2rem mb-2rem">
            <div class="title">총 구매비용(통관금액) :</div>
            <div class="value">{{ regionCurrency }} {{ totalBuyPrice }}</div>
        </div>


    </div>
</template>

<script>
export default {
    props: {
        // csrf-token
        csrfToken: String,

        /**
         * HS코드표 옵션 배열
         */
        hscodeOptions: Array,

        /**
         * hs코드(코드별 전체품목) 옵션배열
         */
        hscodefullOptions: {
            type: Array,
            default: () => {
                return [];
            }
        },

        /**
         * 배송지 옵션 배열
         */
        shippingCenterOptions: {
            type: Array,
            default: () => {
                return [];
            }
        },

        duplicateButtonText: {
            type: String,
            default: '복사'
        },
        removeButtonText: {
            type: String,
            default: '삭제'
        },
        removeConfirm: {
            type: String,
            default: '정말 삭제하겠습니까?'
        },
        lastProdRemoveAlert: {
            type: String,
            default: '마지막 상품을 삭제할 수 없습니다.'
        },

        /**
         * 지역기본 화폐단위
         */
        regionCurrency: {
            type: String,
        },

        /**
         * 초기 설정값
         */
        initItems: {
            type: Array,
            default: null,
        },
    },
    data: function () {
        return {
            // 상품정보 배열
            items: [],

            // 총 구입금액
            totalBuyPrice: 0,
        };
    },
    computed: {},
    watch: {
        // 아이템 변경 감시
        items(val) {
            this.calcTotalBuyPrice();
        },
    },
    mounted: function () {
        if (this.initItems && this.initItems.length > 0) {
            // 초기 설정대로 상품 추가
            _.each(this.initItems, (item) => {
                this.add(item);
            });

        } else {
            // 빈 상품 추가
            this.add();

        }


        // 전역에 현재 컴포넌트 등록
        if (!window.vnodes) {
            window.vnodes = {};
        }
        window.vnodes.appShippingRegProdList = this;
    },
    methods: {

        /**
         * 총 구입금액 계산
         * - prod 컴포넌트에서 구입단가 / 수량 변경이벤트 수신시 실행
         */
        calcTotalBuyPrice() {
            let totalBuyPrice = 0;
            _.each(this.items, (item) => {
                if (item.p_amount && item.p_buy_unit_price) {
                    totalBuyPrice += item.p_amount * item.p_buy_unit_price;
                }
            });
            this.totalBuyPrice = _.round(totalBuyPrice, 2); // float 계산시 소수점 이상하게 표현되서 반올림한번해줌
        },

        /**
         * 상품 추가
         * @param {Object} inits 초기 설정값 객체
         */
        add: function (inits) {
            let default_obj = {
                // 상품정보
                p_prod_code: '',
                p_vender_code: '',
                p_vender_url: '',
                p_vender_mall: '',
                p_img_url: '',
                p_img_file_id: null,
                p_name: '',
                p_brand: '',
                p_color: '',
                p_size: '',
                p_type_name: '',
                p_hscode: '',
                p_unit_price: '',
                p_amount: '',
                p_memo: '',

                // 해외오더
                p_buy_order_code: '',
                p_shipping_center: '',
                p_buy_unit_price: '',
                p_tracking_no: '',
                p_tracking_recipient_name: '',
                p_tracking_onetime_pass: '',


                // 보류요청
                write_hold_request: false,
                hold_request_reason: '',

                // 회원사 주문정보
                hp_order_name: '',
                hp_order_id: '',
                hp_order_at: '',
                hp_order_market: '',
                hp_order_seller: '',
                hp_order_unit_price_krw: '',
                hp_sp_prod_code: '',

            };
            if (inits) {
                Object.assign(default_obj, inits);
            }

            this.items.push(default_obj);
        },
        /**
         * 복사
         * @param index 선택한 배열 index
         */
        duplicate: function (index) {
            this.items.push($.extend({}, this.items[index]));

            //this.rebindAllProd();
        },
        /**
         * 제거
         * @param index 선택한 배열 index
         */
        remove: function (index) {
            if (!confirm(this.removeConfirm)) {
                return;
            }

            if (this.items.length <= 1) {
                alert(this.lastProdRemoveAlert);
                return;
            }
            //console.log('remove is '+index);
            this.items.splice(index, 1);
            //console.log(this.items);

            //this.rebindAllProd();

        },
        /**
         * 모든 상품요소에 대해서 바인딩을 다시함.
         */
        /*
       rebindAllProd: function () {
           this.$nextTick(function () {
               this.$refs.prods.forEach(function (prod) {
                   prod.rebind();
               });
           });

       },
       */
        /**
         * 각 상품 칼럼에 오류메세지를 설정한다.
         * @param errors 오류메세지 배열
         * @param idx 오류난 상품 인덱스
         */
        setErrors: function (errors, idx) {
            _.find(this.$children, function (cmp) {
                if (cmp.index == idx) {
                    /** 하나는 숫자 하나는 문자열일 수 있기때문에, === 비교안함 */
                    // 메세지
                    _.each(errors, function (msg, key) {
                        if (cmp.$refs[key]) {
                            cmp.$refs[key].setState('error', msg);
                        }
                    });

                    return true;
                }
                return false;
            })
            //console.log(idx);
            //console.log(errors);
        }

    }
}
</script>

<style lang="scss" scoped>
.container {
    border-radius: 1rem;
    border: 1px solid #ddd;

    .title {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        font-size: 1.25rem;
        background-color: #fafafa;

        padding: 1rem;
    }


    // 총 구매비용
    .total-buy-price {
        .title {
            font-size: 1.25rem;
            color: #333;
            margin-right: 2rem;
        }

        .value {
            font-size: 2rem;
            color: #0f7ae5;
        }
    }
}
.prod-list {
    margin: 0;

    li {
        border: 1px solid #333;
        padding: 5px;
    }

    li:nth-of-type(odd) {

    }
}

// 추가버튼
.add-button {
    cursor: pointer;
    text-align: center;
}

.add-desc {
    .material-icons {
        color: #0f7ae5;
    }

}


</style>